import {
    getMasqueradeSellerId,
    getMasqueradeBuyerId,
} from 'dibs-cookie-jar/exports/masqueradeHelpers';
import { getDeviceId } from 'dibs-cookie-jar/exports/deviceHelpers';
import serverVars from 'server-vars';

import { QUERY_STRING_HEADER, PASS_THROUGH_PARAM_PREFIXES } from './constants';
import { CreateFetcherArgs } from '../client';

function getPassThroughParams(): Record<string, string> {
    const passThroughParams: Record<string, string> = {};

    if (typeof window !== 'undefined') {
        new URLSearchParams(window.location.search).forEach((value, key) => {
            PASS_THROUGH_PARAM_PREFIXES.forEach(prefix => {
                if (key.startsWith(prefix)) {
                    passThroughParams[key] = value;
                }
            });
        });
    }

    return passThroughParams;
}

export function getClientHeaders(
    getQueries: CreateFetcherArgs['getQueries'],
    userType: CreateFetcherArgs['userType'],
    contextName?: CreateFetcherArgs['contextName']
): Record<string, string> {
    const urlParams = new URLSearchParams({
        ...getPassThroughParams(),
    });

    for (const [key, val] of Object.entries(getQueries())) {
        if (val) {
            urlParams.set(key, val);
        }
    }
    const queryString = urlParams.toString();

    const headers: Record<string, string> = {
        [QUERY_STRING_HEADER]: queryString,
        referer: window.location.href,
    };

    const masqBuyerId = getMasqueradeBuyerId(document.cookie);
    const masqSellerId = getMasqueradeSellerId(document.cookie);
    if (userType === 'buyer' && masqBuyerId) {
        headers['x-dibs-masq-buyer'] = masqBuyerId;
    } else if (userType === 'seller' && masqSellerId) {
        headers['x-dibs-masq-seller'] = masqSellerId;
    }

    const deviceId = getDeviceId(document.cookie);
    if (deviceId) {
        headers['x-dibs-device-id'] = deviceId;
    }

    if (contextName) {
        headers['x-dibs-graphql-network-context'] = contextName;
    }

    const deviceType = serverVars.get('settings.deviceType');
    if (deviceType) {
        headers['x-dibs-device-type'] = deviceType;
    }

    return headers;
}
